import type { FunctionComponent } from 'react';
import { Inline } from '@property.com.au/ui-kit';
import { MediaCountButton } from './subcomponents/MediaCountButton/MediaCountButton';
import { MediaCountIconsMd } from './types';

export type ColorVariants = 'white' | 'grey';
export interface MediaCount {
  iconNameMd: MediaCountIconsMd;
  title: string;
  value: string;
  imageIndexFrom?: number | null;
}

interface MediaCountButtonsProps {
  counts: MediaCount[];
  onClickHandler?: (imageIndexFrom: number) => void;
  variant?: ColorVariants;
  ariaLabel?: string;
}

export const MediaCountButtons: FunctionComponent<MediaCountButtonsProps> = ({
  counts,
  onClickHandler,
  variant = 'white',
  ariaLabel,
}) => {
  return (
    <Inline grow={false} gap="extraSmall">
      {counts.map(({ iconNameMd, title, value, imageIndexFrom }) => (
        <MediaCountButton
          key={title}
          count={{ iconNameMd, title, value, imageIndexFrom }}
          variant={variant}
          onClickHandler={onClickHandler}
          ariaLabel={ariaLabel}
        />
      ))}
    </Inline>
  );
};
